class WIimgandtxtslider extends HTMLElement {

  constructor() {
    super();
  }

  connectedCallback() {

    this.slides = this.querySelectorAll('.WI_imgAndTextBlock_main');

    this.current = 0;

    // Show first slide immediately
    this.slides[0].style.display = "block";
    this.slides[0].style.opacity = "1";

    this.querySelector('[data-prev]').onclick = () => {
      this.changeSlide(this.current - 1);
    };

    this.querySelector('[data-next]').onclick = () => {
      this.changeSlide(this.current + 1);
    };

  }

  changeSlide(index) {

    if (index < 0) {
      index = this.slides.length - 1;
    }

    if (index >= this.slides.length) {
      index = 0;
    }

    // Hide current slide
    this.slides[this.current].style.display = "none";
    this.slides[this.current].style.opacity = "0";

    // Update current slide
    this.current = index;

    // Show new slide
    this.slides[this.current].style.display = "block";
    setTimeout(() => {
        this.slides[this.current].style.opacity = "1";
    }, 10);

  }

}

customElements.define(
  "wi-imageandtext-slider",
  WIimgandtxtslider
);